// frontend/src/components/Suppliers/SupplierStats.jsx
import React from 'react';
import { Building2, CheckCircle, XCircle, Clock, Star } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color }) => (
  <div className="bg-gray-800/50 rounded-xl p-3 sm:p-5 border border-gray-700">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-400 text-xs sm:text-sm">{title}</p>
        <p className="text-lg sm:text-2xl font-bold text-white mt-1">
          {value ?? '—'}
        </p>
      </div>
      <div className={`p-2 sm:p-3 rounded-xl bg-${color}-500/20`}>
        <Icon className={`w-4 h-4 sm:w-6 sm:h-6 text-${color}-400`} />
      </div>
    </div>
  </div>
);

const SupplierStats = ({ stats }) => (
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
    <StatCard title="Total Suppliers"    value={stats.total}     icon={Building2}   color="blue"   />
    <StatCard title="Active"             value={stats.active}    icon={CheckCircle} color="green"  />
    <StatCard title="Inactive"           value={stats.inactive}  icon={XCircle}     color="red"    />
    <StatCard title="Pending"            value={stats.pending}   icon={Clock}       color="yellow" />
    <StatCard title="Preferred"          value={stats.preferred} icon={Star}        color="orange" />
  </div>
);

export default SupplierStats;